import React from 'react';
import { ChannelSelector } from 'components/ChannelSelector';
import { ChannelDetail } from 'components/ChannelDetail';
import { PrivacyText } from 'components/PrivacyText';
import { getChannelDetailsById } from 'utils/getChannelDetailsById';
import { getUrlParam } from 'utils/getUrlParam';
import { ChannelLogo } from 'components/ChannelLogo';

class VrtRadioplayerFrame extends React.Component {
  constructor(props) {
    super(props);

    const channelId = getUrlParam('channel');

    if (!channelId) {
      this.state = { showChannelSelector: true };
    } else {
      let channelDetails = getChannelDetailsById(channelId);

      const activeChannelPlaceholder = channelDetails ? `img/channelPlaceholders/${channelDetails.name}.jpg` : undefined;

      const activeChannelLogo = channelDetails ? `img/channelDogs/${channelDetails.name}.png` : undefined;
      
      this.state = {
        showChannelSelector: false,
        activeChannelPlaceholder,
        activeChannelLogo
      };
    }
  }

  selectChannel = (e) => {
    this.setState(state => ({
      showChannelSelector: !state.showChannelSelector
    }));
  }

  updateBackground = (data) => {
    //set general style
    let backgroundStyle = {
      filter: 'blur(132px)',
      opacity: '1',
      zIndex: '0',
    };
    /*
      height: '500px',
      width: '800px',
    */
    if (data && data.song && data.song.image) {
      //use artist-image
      backgroundStyle = {
        background: `url("${data.song.image}") center center / 270vw 250vh no-repeat fixed, rgba(0,0,0,0)`,
        ...backgroundStyle,
      };
    } else {
      //use channel-placeholder
      backgroundStyle = {
        background: `url("${this.state.activeChannelPlaceholder}") center center / 270vw 250vh no-repeat fixed, rgba(0,0,0,0)`,
        ...backgroundStyle,
      };
    }
    this.setState(state => ({
      radioplayerFrameStyle: backgroundStyle
    }));
  }

  togglePrivacyText = (e) => {
    this.setState(state => ({
      showPrivacyText: !state.showPrivacyText
    }));
  }

  render() {

    const stylesLogoTopLeft = {
      width: '100px',
    }
    
    const imgStyleLogoTopLeft = {
      maxWidth: '8vw',
      maxHeight: '50px',
    }

    return (
      <div className="vrt-radioplayer-frame">
        <div className="backgroundContainer" style={this.state.radioplayerFrameStyle}>
        </div>
        <div className="main">
          { !this.state.showChannelSelector &&
            <ChannelLogo logoUrl={this.state.activeChannelLogo} imgStyle={imgStyleLogoTopLeft} styles={stylesLogoTopLeft} />
          }
          { this.state.showChannelSelector &&
            <div className="channel-selector">
              <ChannelSelector />
            </div>
          }
          { !this.state.showChannelSelector &&
            <div className="channel-logo">
              <ChannelDetail updateStylingHandler={this.updateBackground} channelCode={window.location.search.split('=')[1]} />
            </div>
          }
          { this.state.showPrivacyText && 
            <div className="privacy-text">
              <PrivacyText handler={this.togglePrivacyText} />
            </div> 
          }
          <div className="footer">
            <div>
              <button onClick={this.selectChannel}>
                {this.state.showChannelSelector ? 'X' : 'Kies je radiozender' }
              </button>
            </div>
            <div className="privacy-link" onClick={this.togglePrivacyText}>
              Privacy
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default VrtRadioplayerFrame;